import { DateTime } from "luxon";

export default {
  getShortDateWithTime(dateString) {
    const utcDate = DateTime.fromISO(dateString, { zone: "utc" });
    const swedishTime = utcDate.setZone("Europe/Stockholm");
    return swedishTime.toFormat("yyyy-MM-dd HH:mm");
  },
};
